<template>
  <div>
    <DynamicRender
      :template="globalCustomJs"
      :data="widgetsData"
      :computed="widgetsComputed"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
//import {default as __} from 'lodash';
import DynamicRender from '@/components/DynamicRender'

export default {
  props: [
    'widgetsData',
    'widgetsComputed'
  ],
  components: {
    DynamicRender
  },
  computed: {
    ...mapState([
      'globalCustomJs'
    ])
  }
}
</script>
